<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-sm-12  p-md-12 p-lg-3">

    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Nome" [restricao]="ds.restricoes.atributo('nome')"></m-restricao-string>
        <m-restricao-string label="URL" [restricao]="ds.restricoes.atributo('url')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-fluid p-grid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>

  <div class="p-col-12 p-sm-12  p-md-12 p-lg-9">
    <p-card header="Lista de fontes de dados">
      <p-table
        [multiSortMeta]="ds.ordenacoes"
        [value]="ds.entidades"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortField="id"
        sortMode="multiple"
        styleClass="p-datatable-striped"
        responsiveLayout="scroll"
        emptyMessage="Nenhum registro encontrado">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="id" class="p-id">Id <p-sortIcon field="id"></p-sortIcon>
            </th>
            <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon>
            </th>
            <th pSortableColumn="extrator.recebendoMensagens" style="width: 98px">Hab.<p-sortIcon
                field="extrator.recebendoMensagens"></p-sortIcon>
            </th>
            <th style="width: 120px">Ação</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-entidade>
          <tr>
            <td>{{entidade.id}}</td>
            <td>
              <div class="lista-fonte-nome">
                {{entidade.nome}}
                <br /><span style="font-size: 0.8em;"> Tipo: </span><span
                  style="font-size: 0.7em; font-style: italic">{{entidade.tipo}}</span>
                <br /><span style="font-size: 0.8em;">URL: {{entidade.url}}</span>
                <br /><span style="font-size: 0.8em; font-style: italic">{{entidade.extrator?.orgaoJustica?.nome}}</span>
                <div class="versoes" *ngIf="entidade && entidade.extrator">
                  <span *ngIf="entidade.extrator?.conversorVersaoDataImplantacao" class="label label-info"  [pTooltip]="entidade.extrator?.conversorVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
                    Conversor: {{ entidade.extrator?.conversorVersao }}
                  </span>
                  <span *ngIf="entidade.extrator?.extratorVersaoDataImplantacao" class="label label-info"  [pTooltip]="entidade.extrator?.extratorVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
                    Extrator: {{ entidade.extrator?.extratorVersao }}
                  </span>
                  <span *ngIf="entidade.extrator?.prismaVersaoDataImplantacao" class="label label-info"  [pTooltip]="entidade.extrator?.prismaVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
                    Prisma: {{ entidade.extrator?.prismaVersao }}
                  </span>
                  <span *ngIf="entidade.extrator?.irisVersaoDataImplantacao" class="label label-info"  [pTooltip]="entidade.extrator?.irisVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
                    Iris: {{ entidade.extrator?.irisVersao }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="badge" [ngClass]="entidade.extrator?.recebendoMensagens === true ? 'badge-success' : 'badge-danger'">
                {{entidade.extrator?.recebendoMensagens  | dominio: 'getSimNaoItens'}}
              </span>
            </td>
              <td class="p-text-center">
                <a
                  pButton [routerLink]="['/fonteDados/edicao/', entidade.id]"
                  icon="pi pi-pencil"
                  pTooltip="Editar"
                  class="p-button-sm p-m-r-2">
                </a>
                <button pButton (click)="iniciarExclusao(entidade)"
                 class="p-button-danger p-button-sm"
                  icon="pi pi-trash"
                  pTooltip="Excluir">
                </button>
              </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-6">
              <a pButton routerLink="/fonteDados/novo" class="p-button-primary" label="Novo"></a>
            </div>
            <div class="p-field p-col-6 p-text-right">
              Quantidade de registros: <span class="p-text-bold">{{ds.total}}</span>
            </div>
          </div>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
